import {Component, Input, ViewEncapsulation} from "@angular/core";
@Component({
    selector: 'previous-firmwares-table',
    templateUrl: './previous-firmwares-table.component.html',
    encapsulation: ViewEncapsulation.None
})
export class PreviousFirmwaresTable{
    @Input() firmwares = [];

    preview_html = '';

    preview(id){
        let preview_item = this.firmwares.find(item => item.id == id);
        let preview_english = preview_item.changelogs.find(log => log.language == 'en');
        this.preview_html = preview_english.changelog;
    }
}


// WEBPACK FOOTER //
// ./src/app/front/upload/previous-firmwares-table/previous-firmwares-table.component.ts